// Placeholder - cần chuyển đổi từ app/training_groups/[id]/page.tsx
export default function TrainingGroupDetailPage() {
  return <div>TrainingGroupDetailPage - Đang được chuyển đổi</div>
}

